import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import FieldProto from "../../../../proto/field-proto"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"
import FieldFormElementView from "../../../../render/form-elemnent-view"

const debug = false
// const debug = "FieldCurrency_ConditionForm"

export default class FieldCurrency_ConditionForm extends FieldProto_ConditionForm {
    render() {
        let field: FieldProto | null | false = null

        switch (this.props.condition.type) {
            case ConditionType.NUMBER_LESS_THAN:
            case ConditionType.NUMBER_GREATER_THAN:
            case ConditionType.NUMBER_EQUALS:
                field = FieldsFactory.get({
                    type    : FieldType.NUMBER,
                    fieldId : 'value'
                })
                break


            default:
                break

        }

        debug && console.log(debug, 'render', field)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                {field &&
                    <div className="flex-row-left-center m-l-10">
                        <FieldFormElementView className = "w-150 flex-no-shrink"
                                              field     = {field}
                                              model     = {{value: this.props.condition.value}}
                                              onChange  = {this.onChangeValue}/>
                    </div>}
            </>
        )
    }
}